import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
    DayDropdownValues,
    MonthDropdownValues,
    YearDropdownValues,
    StatesId
} from '../../utils/enums';
import validate from './validations';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';

import { LoadingSpinner } from '../../components/LoadingSpinner';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupFull,
    MultipleGroupLast,
    MultipleGroupFirstMed
} from '../../containers/DefaultStyles/FormDetails';

import DropDownSelect from '../DropDownSelect';

import { getCachedFirstName, getCachedLastName } from '../../utils/formCaching/helpers';

const CheckboxWrapper = styled.div`
    display: flex;
    padding: 2.5px 0;
    @media (min-width: 30em) {
        flex-direction: column;
        position: absolute;
        left: -50%;
        top: 78%;
        padding: 5px 0;
    }
`;
const RemindersNotice = styled.div`
    font-size: 12px;
    font-family: Averta;
    padding-bottom: 5px;

    @media (min-width: 30em) {
        max-width: 160px;
        position: absolute;
        left: -50%;
        top: 68%;
    }
`;

class CheckRegistrationForm extends React.Component {
    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupFull>
                    <Field
                        name="firstName"
                        component={InputGroup}
                        type="text"
                        label="First name"
                        placeholder="First Name"
                        autocomplete="off"
                    />
                    <Field
                        name="lastName"
                        component={InputGroup}
                        type="text"
                        label="Last name"
                        placeholder="Last Name"
                        autocomplete="off"
                    />
                </MultipleGroupFull>
                {!this.props.isMobileResolution && (
                    <MultipleGroupLast>
                        <Field
                            name="address"
                            component={InputGroup}
                            type="text"
                            label="Street No & Street"
                            placeholder="Street No & Street"
                            autocomplete="off"
                        />
                        <Field
                            name="homeCity"
                            component={InputGroup}
                            type="text"
                            label="Home city"
                            placeholder="Home City"
                            autocomplete="off"
                        />
                        <Field
                            name="stateId"
                            component={DropDownSelect}
                            options={this.props.states}
                            defaultOption={'Choose'}
                            label="State"
                            type="text"
                        />
                    </MultipleGroupLast>
                )}
                {this.props.isMobileResolution && (
                    <MultipleGroupFull>
                        <Field
                            name="address"
                            component={InputGroup}
                            type="text"
                            label="Street No & Street"
                            placeholder="Street No & Street"
                            autocomplete="off"
                        />
                        <Field
                            name="homeCity"
                            component={InputGroup}
                            type="text"
                            label="Home city"
                            placeholder="Home City"
                            autocomplete="off"
                        />
                    </MultipleGroupFull>
                )}
                {this.props.isMobileResolution && (
                    <MultipleGroupFull>
                        <Field
                            name="stateId"
                            component={DropDownSelect}
                            options={this.props.states}
                            defaultOption={'Choose'}
                            label="State"
                            type="text"
                        />
                        <Field
                            name="postalCode"
                            component={InputGroup}
                            type="text"
                            label="Postal code"
                            placeholder="Postal code"
                            autocomplete="off"
                            maxLength={5}
                        />
                    </MultipleGroupFull>
                )}
                <MultipleGroupFirstMed>
                    {!this.props.isMobileResolution && (
                        <Field
                            name="postalCode"
                            component={InputGroup}
                            type="text"
                            label="Postal code"
                            placeholder="Postal code"
                            autocomplete="off"
                            maxLength={5}
                        />
                    )}
                    <Field
                        name="month"
                        component={DropDownSelect}
                        options={this.props.month}
                        defaultOption={'Month'}
                        label="DATE OF BIRTH"
                        type="text"
                    />
                    <Field
                        name="day"
                        component={DropDownSelect}
                        options={this.props.day}
                        defaultOption={'Day'}
                        label=""
                        type="text"
                    />
                    <Field
                        name="year"
                        component={DropDownSelect}
                        options={this.props.year}
                        defaultOption={'Year'}
                        label=""
                        type="text"
                    />
                </MultipleGroupFirstMed>
                <MultipleGroupLast>
                    <Field
                        name="email"
                        component={InputGroup}
                        type="email"
                        label="Email"
                        placeholder="Email"
                        autocomplete="off"
                    />
                </MultipleGroupLast>
                <RemindersNotice>Stay informed of key dates and events:</RemindersNotice>
                <CheckboxWrapper>
                    <GetUpdatesCheckbox
                        labelText="Receive Reminders"
                        defaultChecked={true}
                    />
                </CheckboxWrapper>
                <ButtonGroupWrapper
                    isFormSubmitting={this.props.isFormSubmitting}
                    rightPosition={23}
                >
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            className="submitButton"
                            disabled={this.props.invalid}
                            isSubmitting={this.props.isFormSubmitting}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

CheckRegistrationForm.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    isFormSubmitting: PropTypes.bool,
    day: PropTypes.array.isRequired,
    month: PropTypes.array.isRequired,
    year: PropTypes.array.isRequired,
    states: PropTypes.array.isRequired,
    isMobileResolution: PropTypes.bool.isRequired
};

export default compose(
    connect(state => ({
        initialValues: {
            getUpdates: true,
            firstName: getCachedFirstName(state),
            lastName: getCachedLastName(state),
            address:
                state.cachedFormData.homeAddress || state.cachedFormData.address || '',
            homeCity: state.cachedFormData.homeCity || '',
            stateId: state.cachedFormData.stateId || '',
            postalCode: state.cachedFormData.postalCode || '',
            month: state.cachedFormData.month || '',
            day: state.cachedFormData.day || '',
            year: state.cachedFormData.year || '',
            email: state.cachedFormData.email || ''
        },
        day: DayDropdownValues(),
        month: MonthDropdownValues,
        year: YearDropdownValues(),
        states: StatesId,
        isMobileResolution: state.widget.isMobileResolution
    })),
    reduxForm({
        form: 'checkRegistrationForm',
        destroyOnUnmount: false,
        validate
    })
)(CheckRegistrationForm);



// WEBPACK FOOTER //
// ./src/components/CheckRegistration/CheckRegistrationForm.jsx